import React from 'react';
import PropTypes from 'prop-types';
import CaseStudyItem from "../CaseStudyItem/CaseStudyItem";

const propTypes = {
  caseStudies: PropTypes.array.isRequired
};

const CaseStudiesList = ({caseStudies}) => {

    return (
        <section className="section sectionResources">
          <div className="container">
            <ul className="resources">
              {caseStudies.map(cs =>
                <li
                  key={cs.node.id}
                  className="resource"
                >
                  <CaseStudyItem
                    cs={cs.node}
                  />
                </li>
              )}
            </ul>
          </div>
        </section>
    );
};

CaseStudiesList.propTypes = propTypes

export default CaseStudiesList;
